module.exports = __webpack_public_path__ + "img/downAppCode6.9b3d2d4a.png";